<div class="tooltip-container" [class.tooltip-bottom]="tooltipBottom">
  <ng-content></ng-content>
  <div class="tooltip" *ngIf="tooltipVisible">
    <ng-content select="[tooltip-content]"></ng-content>
    <span *ngIf="text">{{ title | text }}</span>
  </div>
</div>
